{
	"optionsBoardWidgetActions": {
		"settingsColumns": "Настройка колонок",
		"columns": {
			"strike": "Страйк",
			"bid": "Bid",
			"ask": "Ask",
			"last": "Цена",
			"change": "Сегодня %",
			"breakeven": "Безубыток",
			"volatility": "Импл. Вол.",
			"interest": "Откр. инт.",
			"delta": "Дельта",
			"gamma": "Гамма",
			"theta": "Тэта",
			"vega": "Вега"
		}
	}
}
